/**
 * 订单续约
 */

import { CATEGORY_CODE_MAP, FEE_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import moment from 'moment'
import { defaultContext } from './defaultContext.js'

export const orderRenewalContext = {
  clearFormData() {
    // 续约不清车牌号和车型
    this.plateNoList = []
    this.rentInfo_model.startStopDate = []
    this.rentInfo_model.presentDays = ''
    this.$emit('manualChangeStartStopDate')
    this.$nextTick(() => {
      this.$refs.rentInfoBox.clearValidate()
    })
  },
  onMounted() {
    // 获取租赁方案
    this.getRentPlanList()
    // 获取租赁方案详情
    if (this.planId) {
      const { startStopDate } = this.rentInfo_model
      this.getPlanDetail({
        ...this.context.generateGetPlanDetailsParams(),
        startDate: (startStopDate && startStopDate[0]) || this.availablePaymentStartDate,
      })
    }
  },
  onPlanChange(planId) {
    if (planId) {
      this.getPlanDetail({
        ...this.context.generateGetPlanDetailsParams(),
        planId,
        startDate: this.availablePaymentStartDate,
      })
    }
    this.clearFormData()
  },
  generateGetPlanParams() {
    return {
      ...defaultContext.generateGetPlanParams.call(this),
      modelId: this.rentInfo_model.modelId,
    }
  },
  // 这是一个Array.prototype.map的reducer工厂，返回的reduer供某一个租赁方案里的费项列表使用
  // this.getPlanDetail()里获取租赁方案详情时会使用
  // this.mounted()里，获取完“可用计租费项”后，也会调用
  onSetFee(feeList) {
    return defaultContext.onSetFee.call(this, feeList)
  },
  getFeeItem(data, extData) {
    const feeItem = defaultContext.getFeeItem.call(this, data, extData)
    feeItem.isConfirm = true

    return feeItem
  },
  onAddRequiredFee(requiredFees) {
    if (Number(this.rentInfo_model.rentCategory) === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) {
      this.yaJinObj.fundType = FEE_CODE_MAP.SHOU_FU_KUAN
    } else {
      this.yaJinObj.fundType = FEE_CODE_MAP.YA_JIN
    }
    return requiredFees.map((item) => {
      let newItem = item
      if (this.rentInfo_model.isTranDeposit) {
        if (newItem.fundType === this.yaJinObj.fundType) {
          newItem = Object.assign({}, newItem, this.yaJinObj)
        }
      }
      return newItem
    })
  },
  async onTranDepositChange() {
    if (this.rentInfo_model.planId && this.rentInfo_model.startStopDate) {
      this.getPlanDetail({
        ...this.context.generateGetPlanDetailsParams(),
        startDate: this.rentInfo_model.startStopDate[0],
      })
    } else {
      this.queryFeeList().then((feeList) => this.addRequiredFee(feeList, 'fromEvent'))
    }
  },
  onPick(time) {
    this.getPlanDetail({
      ...this.context.generateGetPlanDetailsParams(),
      startDate: moment(time.minDate).format('YYYY-MM-DD HH:mm:ss'),
    })
  },
  generateGetPlanDetailsParams() {
    const params = {
      planId: this.planId || this.rentInfo_model.planId,
      depositTransfer: this.rentInfo_model.isTranDeposit,
      oldOrderId: this.rentInfo_model.relatedOrderId,
    }
    return params
  },
}
